import { render, staticRenderFns } from "./FarmerStatement.vue?vue&type=template&id=e4904804"
import script from "./FarmerStatement.vue?vue&type=script&lang=js"
export * from "./FarmerStatement.vue?vue&type=script&lang=js"
import style0 from "./FarmerStatement.vue?vue&type=style&index=0&id=e4904804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports